<script setup lang="ts">
defineProps<{
  grid?: boolean
  titleClass?: string
  gridClass?: string
}>()
</script>

<template>
  <div class="space-y-2">
    <div
      class="text-center"
      :class="{ [`${titleClass}`]: titleClass }"
    >
      <slot name="title" />
    </div>
    <div
      :class="{
        'grid grid-flow-row grid-cols-3 gap-1 @md:grid-cols-4': grid,
        [`${gridClass}`]: gridClass,
      }"
    >
      <slot />
    </div>
  </div>
</template>
